import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { Add } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import { AuthContext } from "../../../../context/AuthContext";

const filter = createFilterOptions();

const SelectManufacturingOrder = ({
  value,
  label = "Manufacturing Orders",
  onUpdate,
  disabled,
  onBlur,
  error,
  helperText,
  ...props
}) => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [manufacturingOrders, setManufacturingOrders] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const getManufacturingOrders = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/cfi/manufacturing-orders`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status == 201) {
        let mfgOrders = response.data.manufacturingOrders;
        setManufacturingOrders(mfgOrders);
        setHasLoaded(true);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // If the value is set but the list isn't loaded yet then load the list
  // If this isn't done, the value is set on the state but not shown on the TextField
  // because it matches nothing on a list that is empty
  useEffect(() => {
    if (manufacturingOrders.length == 0) {
      getManufacturingOrders();
    }
  }, [value]);

  if (hasLoaded) {
    // This makes sure the sales rep list is loaded before showing the autocomplete
    // (because the sales rep is updated when the customer is selected)
    return (
      <>
        <Autocomplete
          value={value}
          disabled={disabled}
          handleHomeEndKeys
          onChange={(event, newValue) => {
            // console.log("Value is object or null", newValue);
            // console.log("SET VALUE", newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }}
          onInputChange={() => {
            // console.log("onInputChange");
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            return filtered;
          }}
          options={manufacturingOrders}
          getOptionLabel={(option) => {
            //   console.log("Option", option);
            // for example value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            return `MO #${option.id}`;
          }}
          selectOnFocus
          clearOnBlur
          isOptionEqualToValue={(option, value) => {
            //  The "selected" prop on renderOption depends on this
            if (!value) return false;
            return value.id == option.id;
          }}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              size={props.size ? props.size : "small"}
              label={label}
              sx={{
                width: "100%",
              }}
              variant="outlined" // filled, outlined, standard
              onBlur={onBlur}
              error={error}
              helperText={helperText}
            />
          )}
        />
      </>
    );
  }
};

export default SelectManufacturingOrder;
